import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = { class: "btn btn-link btn-sm" }
const _hoisted_6 = { class: "btn btn-link btn-sm" }
const _hoisted_7 = { class: "col-lg-5 col-sm-6 text-right" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { key: 1 }

import { computed, onMounted } from 'vue'
    import { useRoute } from 'vue-router'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import UsersTable from '@Organizations/Users/Components/UsersTable.vue'
    import { useSearchAllUsersQueryV1 } from '@Organizations/Users/queries-vue-composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceAccountsPage',
  setup(__props) {

    const route = useRoute()
    const tid = computed(() => Number(route.params.tid))
    
    const {
        runSearchAllUsersQueryV1,
        modelSearchAllUsersQueryV1: allUsersSearchResult
    } = useSearchAllUsersQueryV1(tid, '', true, false, false, true)
    // includeServiceAccounts = true → ONLY service accounts returned


    const users = computed(() => allUsersSearchResult.value?.Users ?? [])
    const serviceAccounts = users // already filtered by query

    onMounted(() =>
    {
        document.title = 'Service Accounts'
        runSearchAllUsersQueryV1()
    })

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: tid.value }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }, "Service Accounts", -1 /* CACHED */)),
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", {
              class: "fa fa-lock",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Locked service accounts ", -1 /* CACHED */)
          ]))])), [
            [_directive_sanitizedHref, `/#/admin/organizations/users/service-accounts/locked/${tid.value}`]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_6, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", {
              class: "fa fa-user-times",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Deleted service accounts ", -1 /* CACHED */)
          ]))])), [
            [_directive_sanitizedHref, `/#/admin/organizations/users/service-accounts/deleted/${tid.value}`]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("a", {
            href: `/#/admin/organizations/users/create-service-account/${tid.value}`,
            class: "btn btn-success text-white",
            style: {"padding":"0.7em 2em"}
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("i", {
              class: "fa fa-plus",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Create service account ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_8)
        ])
      ])
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_9, [
      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-muted" }, "Service accounts are used for API access and automation. They cannot sign in through the UI.", -1 /* CACHED */)),
      (_unref(serviceAccounts).length)
        ? (_openBlock(), _createBlock(UsersTable, {
            key: 0,
            users: _unref(serviceAccounts),
            showActive: false
          }, null, 8 /* PROPS */, ["users"]))
        : (_openBlock(), _createElementBlock("h4", _hoisted_10, "No service accounts found"))
    ])
  ]))
}
}

})